export default __webpack_public_path__ + "static/13_33-c7e88d08eb1793b5021a464737461b90.png";